import { render, staticRenderFns } from "./dialogNotice.vue?vue&type=template&id=7ea974fe&scoped=true&"
import script from "./dialogNotice.vue?vue&type=script&lang=js&"
export * from "./dialogNotice.vue?vue&type=script&lang=js&"
import style0 from "./dialogNotice.vue?vue&type=style&index=0&id=7ea974fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea974fe",
  null
  
)

export default component.exports